import styled from 'styled-components';

export const DocsVerificationWidgetContainer = styled.div`
    * {
        -webkit-tap-highlight-color: transparent;
        outline: none;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
    }
`;
